import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { Checkbox, Divider, FormHelperText, TextField } from '@material-ui/core'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import FlexView from 'react-flexview/lib'
import { isOver18 } from '../../services/utils'
import { FormProvider, useForm } from 'react-hook-form'
import { ReactComponent as PilotSvg } from '../../assets/pilot_blue.svg'
import { SkywatchDialog } from './SkywatchDialog'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { UserSection } from '../UserProfile/ProfileSections/UserSection'
import { AddressSection } from '../UserProfile/ProfileSections/AddressSection'
import NewFillButton from '../Core/NewFillButton'

export const ParentPopup = () => {
  const [open, setOpen] = React.useState(false)
  const methods = useForm({ mode: 'onChange' })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleDisagree = () => {
    setOpen(false)
  }

  const handleAgree = async () => {
    let valid = await methods.trigger()

    if (!valid) return

    if (!isOver18(new Date(methods.getValues()['dob']))) {
      methods.setError('dob', {
        type: 'validate',
        message: 'must be 18 or above',
      })
      return
    }

    EventEmitterService.dispatch(
      EventKey.SHOW_PARENT_POPUP_FINISH,
      methods.getValues()
    )

    setOpen(false)
  }

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(EventKey.SHOW_PARENT_POPUP, () => {
      handleClickOpen()
    })

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.SHOW_PARENT_POPUP, id)
    }
  }, [])

  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleDisagree}
      maxWidth={'md'}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <PilotSvg />{' '}
        </ElevatedCircle>
      }
      closeTitle={'Modify Policy Holder'}>
      <FlexView column id={'parent-holder-form'}>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">
          Enter the Name of Parent or Legal Guardian for the Pilot
        </div>
        <FormProvider {...methods}>
          <UserSection isParentMode={true} />
          <Divider />
          <div className="text-small-title black bold">Address</div>
          <AddressSection isParentMode={true} />
        </FormProvider>
        <NewFillButton flat onClick={handleAgree}>
          OK
        </NewFillButton>
        <div
          onClick={handleDisagree}
          className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
